import { call, put } from "redux-saga/effects";
import { AxiosError, AxiosResponse } from "axios";

// Response / Request
import { Result } from "@models/common/resultResponse";
import { KeyValue } from "@/main/models/common";

// Redux
import { GetYearByManufacturerAndModel, GetYears, saveYears } from "./index";

// Api's
import { yearApi } from "../../../api";
import { errorBoundaryReduxSaga, renderErrorReduxSaga } from "@/main/services/utils";

export function* getYearsSaga(action: GetYears) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(yearApi.getVehicleYear);
		if (response.data.result) {
			yield put(saveYears(response.data.result, false, null, action.payload.keyReducer));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveYears(null, true, resultError.messagesDataError, action.payload.keyReducer));
		}
	}
}
export function* getYearByManufacturerAndModelSaga(action: GetYearByManufacturerAndModel) {
	try {
		const response: AxiosResponse<Result<KeyValue[]>> = yield call(
			yearApi.getVehicleYearByManufacturerAndModel,
			action.payload.request,
		);
		if (response.data.result) {
			yield put(saveYears(response.data.result, false, null, action.payload.keyReducer));
		}
	} catch (exception) {
		if (exception instanceof AxiosError) {
			const resultError = errorBoundaryReduxSaga(exception);
			renderErrorReduxSaga(resultError);

			yield put(saveYears(null, true, resultError.messagesDataError, action.payload.keyReducer));
		}
	}
}
